document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll(".price-item--regular").forEach(function(price) {
        price.textContent = price.textContent.replace(/^From\s+/i, ""); // Removes "From"
    });

    let section = document.querySelector("#shopify-section-template--16765759291491__hero_image_with_text_attqpP");
    
    if (section) {
        section.style.cursor = "pointer"; 
        section.addEventListener("click", function() {
            window.location.href = "https://briellaluxury.com/products/fashion-elegant-cross-pleated-maxi-dress";
        });
    }

  let section_2 = document.querySelector("#shopify-section-template--16765759291491__hero_image_with_text_YCyWr4");
    
    if (section_2) {
        section_2.style.cursor = "pointer"; 
        section_2.addEventListener("click", function() {
            window.location.href = "https://briellaluxury.com/products/womens-bikini-summer-swimsuit-front-cross-lace-up-two-piece-bathing-suit";
        });
    }


  let section_3 = document.querySelector("#shopify-section-template--16765759291491__countdown_banner");
    
    if (section_3) {
        section_3.style.cursor = "pointer"; 
        section_3.addEventListener("click", function() {
            window.location.href = "https://briellaluxury.com/products/womens-casual-hooded-sweater-two-piece-suit-clothes-hoodie-tracksuit";
        });
    }



    document.querySelectorAll("footer button span").forEach(function(span) {
        let text = span.textContent.trim();

        if (text === "Refund policy") {
            span.textContent = "Return Policy";
        } else if (text === "Shipping policy") {
            span.textContent = "Shipping Policy"; // Capitalized
        } else if (text === "Privacy policy") {
            span.textContent = "Privacy Policy"; // Capitalized
        } else if (text === "Terms of service") {
            span.textContent = "Terms Of Service"; // Capitalized 'Of'
        }
});

});

document.addEventListener("DOMContentLoaded", function() {
    function updateFooterText() {
        document.querySelectorAll("footer button span").forEach(function(span) {
            let text = span.textContent.trim();

            if (text === "Refund policy") {
                span.textContent = "Return Policy";
            } else if (text === "Shipping policy") {
                span.textContent = "Shipping Policy";
            } else if (text === "Privacy policy") {
                span.textContent = "Privacy Policy";
            } else if (text === "Terms of service") {
                span.textContent = "Terms Of Service";
            }
        });
    }

    // Run the function initially in case elements are already present
    updateFooterText();

    // Observe the footer for changes in case elements load later
    const observer = new MutationObserver(updateFooterText);
    observer.observe(document.body, { childList: true, subtree: true });
});
